<template>
  <div>
    <acheader></acheader>
    <div class="row mainbody">
      <div class="col-lg-2 col-md-4 col-sm-12">
        <poolsidebar></poolsidebar>
      </div>
      <div class="col-lg-10 col-md-8 col-sm-12">
        <div class="moduleWrapper">
        
          <div v-if="allBundles!==null">
            <div v-show="allBundles.length>0">
              <div v-for="bundle in allBundles" class="moduleCard mb-4">
                <div class="row">
                  <div class="col-12">
                    <h3>{{bundle.BundleName}}</h3>
                  </div>
                </div>
                <div class="row mt-2">
                  <div class="col-3 rightborder">
                    <div class="row">
                      <div class="col-8">
                        Remaining
                      </div>
                      <div class="col-4">
                        {{bundle.NumberAvailable}}
                      </div>
                    </div>
                    <div class="row mt-1">
                      <div class="col-8">
                        Members
                      </div>
                      <div class="col-4">
                        {{bundle.NumberAssigned}}  <button class="btn-transparent" @click="goToUsers(bundle.BundleID)"><font-awesome-icon icon="edit"></font-awesome-icon></button>
                      </div>
                    </div>
                    <div class="row mt-1">
                      <div class="col-8">
                        Term (Days)
                      </div>
                      <div class="col-4">
                        {{bundle.Term}}
                      </div>
                    </div>
                    <div class="row mt-1">
                      <div class="col-8">
                        Max Expiration Date
                      </div>
                      <div class="col-4">
                        {{bundle.MaxExpirationDate}}
                      </div>
                    </div>
                    <div class="row mt-1">
                      <div class="col-8">
                        Schedules
                      </div>
                      <div class="col-4">
                        <button class="btn-transparent" @click="goToSchedules(bundle.BundleID)"><font-awesome-icon icon="edit"></font-awesome-icon></button>
                      </div>
                    </div>
                  </div>
                  <div class="col-9">
                    <h5>Products</h5>
                    <div v-for="pr in bundle.BundleProducts" class="row mb-1">
                        <div class="col-6">
                          {{pr.ProductName}}
                        </div>
                        <div class="col-2">
                          {{pr.Available}}
                        </div>
                        <div class="col-2">
                          <button class="btn btn-secondary btn-short smallheight nopadding" @click="openBundleProductAvailability(pr)">Availability</button>
                        </div>
                        <div class="col-2">
                          <button class="btn btn-secondary btn-short smallheight nopadding" @click="openBundleLog(pr.BundleProductID)">Log</button>
                        </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-show="allBundles.length===0">
              This License Pool does not have any bundles
            </div>
          </div>

        </div>
      </div>
    </div>
    <b-modal ref="bundleLog" size="xl" scrollable title="Bundle Log">
       <div v-if="bundlelog!==null">
          <div class="row mt-2" v-for="logentry in bundlelog" v-if="bundlelog.length>0">
             <div class="col-4">
               {{logentry.LogDate}}
             </div>
             <div class="col-8">
               {{logentry.LogEntry}}
             </div>
          </div>
          <div v-if="bundlelog.length===0">
              There are no log entries
          </div>
       </div>
    </b-modal>
    <b-modal ref="bundleProductAvailability" title="Bundle Product Availability" @ok="doProductBundleAvailability">
      <div v-if="product!==null">
        <p>This feature allows you to make {{product.ProductName}} available or unavailable for all assigned members.</p>
        <p>
          <b>Available</b> = Members will be able to see and use the product.<br />
          <b>Unavailable</b> = Members will not be able to see or use the product.
        </p>
        <p>
          <input type='radio' value="on" v-model="productonoff" name='prdonoff' />&nbsp;Make this product available for all assigned members<br />
          <input type='radio' value="off" v-model="productonoff" name='prdonoff' />&nbsp;Make this product unavailable for all assigned members
        </p>
      </div>
    </b-modal>
    <acfooter></acfooter>
  </div>
</template>

<style scoped>
   .rightborder {
      border-right:1px solid #666;
   }
</style>

<script>
  import acheader from "../../layout/Header.vue"
  import acfooter from "../../layout/Footer.vue"
  import poolsidebar from "../../layout/Pool/Sidebar.vue"

  export default {
    name: 'PoolBundles',
    components: {acheader,acfooter,poolsidebar},
    data() {
      return {
        allBundles:null,
        bundlelog:null,
        canEdit:false,
        product:null,
        productonoff:'on'
      }
    },
    methods: {
      doProductBundleAvailability() {
        this.apiCommand([
          {
            Operation: "LicensePool",
            Function: "ToggleBundleProduct",
            Fields: {
              LicensePoolID: this.sdata.activepool.LicensePoolID,
              BundleID: this.product.BundleID,
              BundleProductID: this.product.BundleProductID,
              OnOff: this.productonoff==='on'?"true":"false"
            }
          }
        ]).then(r=>{
          this.popDialog(0, "Product Availability Successfully Changed");
        })
      },
      goToSchedules(bid) {
        this.$router.push("/bundles/"+this.sdata.activepool.LicensePoolID+"/"+bid+"/schedules")
      },
      goToUsers(bid) {
        this.$router.push("/bundles/"+this.sdata.activepool.LicensePoolID+"/"+bid+"/users")
      },
      openBundleProductAvailability(bdlpr) {
        this.product=bdlpr;
        this.productonoff='on';
        this.$refs["bundleProductAvailability"].show();
      },
      openBundleLog(bundleProductID) {
        this.apiCommand([
          {
            Operation: "LicensePool",
            Function: "GetBundleProductLog",
            Fields: {
              LicensePoolID: this.sdata.activepool.LicensePoolID,                       
              BundleProductID: bundleProductID
            }
          }
        ]).then(response=> {
          var cr = JSON.parse(response.CommandResult);
          var bl = JSON.parse(cr.returnObjects[0].returnObject);
          for(var ble of bl) {
            ble.LogDate = this.buildDateTime(ble.LogDate, true);
          }

          this.bundlelog=bl;
          this.$refs["bundleLog"].show();
        });
      }
    },
    mounted() {
      this.doPage().then(r=>{
        this.bootstrapPool(this.$route.params.id);

        this.apiCommand([
          {
            Operation: "LicensePool",
            Function: "GetBundles",
            Fields: {
              LicensePoolID: this.$route.params.id
            }
          },
          {
            Operation: "LicensePool",
            Function: "GetBundleProducts",
            Fields: {
              LicensePoolID: this.$route.params.id
            }
          }
        ]).then(r=> {
          var cr = JSON.parse(r.CommandResult);
          var bundles = JSON.parse(cr.returnObjects[0].returnObject);
          var products = JSON.parse(cr.returnObjects[1].returnObject);

          for(var bundle of bundles) {
            if (bundle.Term===null) {
              bundle.Term="N/A";
            }

            bundle.MaxExpirationDate=this.buildDateTime(bundle.BundleExpirationDate,false);

            for(var bundleproduct of bundle.BundleProducts) {
              for(var product of products) {
                if (product.BundleID===bundleproduct.BundleID && bundleproduct.ProductID===product.ProductID) {
                  bundleproduct.ProductName=product.ProductName;
                }
              }
              bundleproduct.Available = bundleproduct.EnableImmediately ? "Available On Start" : "Availability Delayed";
            }
          }

          this.canEdit = this.sdata.activepool.IsAdmin;
          this.allBundles=bundles;

        });

      });
    }
  }
</script>
